// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-color{color:#39a8d8}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Common/Breadcrumbs.vue"],"names":[],"mappings":"AAMA,YACC,aACD","sourcesContent":["<template>\n    <div class=\"w-full xl:px-10 px-5 pt-12\"><slot></slot>\n    </div>\n</template>\n\n<style>\n.link-color{\n color: #39a8d8;\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
